import Events from 'events';

/**
 * 取消绑定事件
 */
Events.EventEmitter.prototype.off = Events.EventEmitter.prototype.removeListener;

const emitter = new Events.EventEmitter();

const genEvent = (eventID) => {
    return (handler, once = false) => {
        let safeHandler = (...args) => {
            try {
                handler(...args);
            } catch (ex) {
                console.error(ex);
            }
        };
        let handleWrap = safeHandler;
        if (once) {
            handleWrap = (...args) => {
                emitter.removeListener(eventID, handleWrap);
                safeHandler(...args);
            };
        }

        emitter.addListener(eventID, handleWrap);
        return () => emitter.removeListener(eventID, handleWrap);
    };
};

if (!IS_BUILD_PRODUCTION) {
    // TODO: 全局对象的暴露尽量使用生僻变量
    window.Emitter = emitter;
}

export {
    genEvent,
    emitter as default
};
